export const urls = {
baseUrl: "https://lacarabela.pickingmalaga.es/portal_empresa",
tenant: "picking"
}

